module.exports = __webpack_public_path__ + "static/media/regularlyPerform.d3737071.svg";